import {Component, Input, OnInit, ViewChild,} from '@angular/core';
import {ModalController, PopoverController} from "@ionic/angular";
import {Router} from "@angular/router";
import {GROUP_TYPE_CAMP, PAYMENT_LINK} from "../../constants";
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";
import {PreloaderService} from "../../../services/preloader/preloader.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {ViewTestComponent} from "../modals/view-test/view-test.component";
import {APP_HOST} from "../../../../providers/config";

@Component({
    selector: 'app-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
})
export class GroupComponent implements OnInit {
    windowWidth: number;

    @ViewChild('myPopover', {static: false}) myPopover: any;

    @Input() group: any;
    @Input() class: string = '';

    protected readonly GROUP_TYPE_CAMP = GROUP_TYPE_CAMP;
    lessons: any[] = [];

    constructor(
        public popoverController: PopoverController,
        private router: Router,
        public myGcService: MyGreenCountry,
        private preloaderService: PreloaderService,
        private sanitizer: DomSanitizer,
        private modalCtrl: ModalController,
    ) {
    }

    ngOnInit() {
        this.initializeLessons();
        this.windowWidth = window.innerWidth;

    }


    initializeLessons() {
        this.lessons = this.group.studyProgress.lessons;

    }


    goToStudyProgress(targetGroupId: string) {
        let type = this.group.time === 'isFuture' ? 'future' : this.group.time === 'isCurrent' ? 'current' : 'past';

        this.router.navigate(['/study-progress', type, targetGroupId]);
    }



    async openCertificate(url: string) {
        let  route = url.replace(APP_HOST, "");
        this.router.navigate([ route]);

        // this.myGcService.openUrl(url)
    }



    // async openCertificate(uuid: string) {
    //     await this.preloaderService.showLoading("Зачекайте, будь ласка ");
    //
    //     this.myGcService
    //         .openCertificate(uuid)
    //
    //         .subscribe({
    //             next: (response) => {
    //
    //                 if (response.html) {
    //                     this.openTestModal(response.html)
    //                 }
    //
    //
    //             },
    //
    //             error: (error) => {
    //                 console.log('error', error)
    //
    //             },
    //
    //             complete:
    //                 () => {
    //                     this.preloaderService.hideLoading();
    //                 }
    //
    //         })
    // }


    onResize(event: Event) {
        this.windowWidth = (event.target as Window).innerWidth;
    }

    isSmallScreen(): boolean {
        return this.windowWidth < 768;
    }


    async openTestModal(html: string) {

        const modal = await this.modalCtrl.create({
            component: ViewTestComponent,
            cssClass: 'auto-height full-height',
            componentProps: {
                html: html
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }
}
